import { forwardRef } from 'react'
import { Calendar } from 'src/assets'

interface Props {
  dropdownOpen?: boolean
  toggleDropdown?: () => void
  label: string
  error?: string
  value: string | undefined
  suffixIcon?: React.ReactNode
}

const DatePickerInput = (
  { error, dropdownOpen, value, toggleDropdown, label, suffixIcon }: Props,
  ref: any
) => {
  const classes = [
    'min-w-[350px]',
    'w-full',
    'relative',
    'bg-light-gray',
    'border',
    'transition-all',
    'duration-500',
    'h-[52px]',
    'p-md',
    error ? 'border-red' : 'border-light-gray',
    'disabled:text-dark-gray',
    dropdownOpen ? 'rounded-t-sm' : 'rounded-sm',
  ]

  const labelClasses = [
    'absolute',
    'left-[15px]',
    'z-10',
    'transition-all',
    'duration-500',
    !!value ? 'top-[5px] tiny-normal' : 'top-[15px] base-normal',
    error ? 'text-red' : 'text-dark-gray',
    'truncate ...',
    'w-10/12',
    'pointer-events-none',
  ]

  return (
    <div
      className={classes.join(' ')}
      onClick={toggleDropdown}
      tabIndex={0}
      ref={ref}
    >
      {label && <div className={labelClasses.join(' ')}>{label}</div>}
      <div className='flex flex-wrap gap-[15px]'>
        <div className='grow truncate ...'>{value}</div>
        {suffixIcon || <Calendar className='my-[3px] fill-black' />}
      </div>
    </div>
  )
}

export default forwardRef(DatePickerInput)
